'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _getClientConfig = require('./getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _lodash.memoize)(function () {
  return (0, _getClientConfig2.default)().apiRoot || location.protocol + '//' + window.location.host;
});


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/getAppUrl.js
// module id = 760
// module chunks = 0